import React from 'react';
import { ViewState } from '../types';

interface NavigationProps {
  currentView: ViewState;
  setView: (view: ViewState) => void;
  isCoachAnalyzing?: boolean;
}

export const Navigation: React.FC<NavigationProps> = ({ currentView, setView, isCoachAnalyzing }) => {
  return (
    <nav className="fixed bottom-0 left-0 w-full h-20 bg-white dark:bg-[#0c1a11] border-t border-gray-100 dark:border-white/5 z-50 px-4 pb-4 pt-2">
      <ul className="flex justify-around items-center h-full">
        <li 
          onClick={() => setView('list')}
          className={`flex flex-col items-center gap-1 w-14 cursor-pointer transition ${currentView === 'list' ? 'text-primary' : 'text-gray-400 dark:text-gray-500'}`}
        >
          <span className={`material-symbols-outlined text-2xl ${currentView === 'list' ? 'filled' : ''}`}>format_list_bulleted</span>
          <span className="text-[10px] font-medium">Lijst</span>
        </li>
        
        <li 
          onClick={() => setView('recipes')}
          className={`flex flex-col items-center gap-1 w-14 cursor-pointer transition ${currentView === 'recipes' || currentView === 'recipe-detail' ? 'text-primary' : 'text-gray-400 dark:text-gray-500'}`}
        >
          <span className={`material-symbols-outlined text-2xl ${currentView === 'recipes' ? 'filled' : ''}`}>menu_book</span>
          <span className="text-[10px] font-medium">Recepten</span>
        </li>

        <li 
          onClick={() => setView('coach')}
          className={`flex flex-col items-center gap-1 w-14 cursor-pointer transition ${currentView === 'coach' ? 'text-primary' : 'text-gray-400 dark:text-gray-500'} relative`}
        >
          <div className="relative">
            <span className={`material-symbols-outlined text-2xl ${currentView === 'coach' ? 'filled' : ''}`}>kitchen</span>
            {isCoachAnalyzing && (
                <span className="absolute -top-1 -right-1 flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-primary"></span>
                </span>
            )}
          </div>
          <span className="text-[10px] font-medium">{isCoachAnalyzing ? 'Bezig...' : 'Coach'}</span>
        </li>
        
        <li 
          onClick={() => setView('settings')}
          className={`flex flex-col items-center gap-1 w-14 cursor-pointer transition ${currentView === 'settings' ? 'text-primary' : 'text-gray-400 dark:text-gray-500'}`}
        >
          <span className={`material-symbols-outlined text-2xl ${currentView === 'settings' ? 'filled' : ''}`}>settings</span>
          <span className="text-[10px] font-medium">Opties</span>
        </li>
      </ul>
    </nav>
  );
};